<template>
  <div>
    <div class="award-banner">
      <span class="blind">이마티콘배너</span> <!--배너에 대한 내용이 들어가면 됩니다.-->
    </div>
    <div class="award-contents">
      <h1>점포 시상코드 입력<p>※ 본인 시상 불가</p></h1>
      <input type="text" placeholder="점포별 시상코드를 입력하세요."
             v-model="awardCode">
      <p v-if="!awardCodeCheck">입력하신 점포코드가 존재하지 않습니다.<br>확인 후, 다시 입력해 주세요.</p><!--존재하지 않을경우 보이게-->
    </div>
    <div class="fixed" @click="getAwardToken()">
      <bottom-button :buttonArray="buttonArray"></bottom-button>
    </div>
    <award-popup v-if="awardAlert"></award-popup>
  </div>
</template>
<script>
import BottomButton from '@/components/common/BottomButton.vue';
import apiList from "@/api/apiList";
import awardPopup from "@/views/award/awardPopup";
import store from "@/store";
export default {
  name: "awardCode",
  components: { BottomButton , awardPopup},
  data() {
    return {
      buttonArray: [
        {
          className: "button-disabled",
          text: "확인",
        },
      ],
      // awardCode: "1005KEP",
      // awardCode: "0000AAA",
      awardCode: "",
      awardCodeCheck : true,
      awardAlert : false
    };
  },
  watch: {
    awardCode(code) {     // 확인 버튼 활성화, 비활성화 처리
      if(code.length < 4) {
        this.buttonArray[0].className = 'button-disabled'
      } else {
        this.buttonArray[0].className = 'button-bg-yellow'
      }
    }
  },
  mounted() {
    // this.$heading('이마티콘');
    this.mberInit(); //회원 초기화
  },
  methods: {
    async getAwardToken() {
      // awardCode 입력된 데이터가 없을 경우 토큰발급 api 호출 방지
      if(this.awardCode.length < 4) {
        return;
      }

      try {
        const param = {
          mberNo : this.awardCode
        }

        const response = await apiList.getAwardCode(param);

        if (response.data.code === 'S00000') {
          this.awardAlert = true;
          //검증 성공 시 회원번호 세팅
          let mberNo = response.data.data.mberNo;
          if(mberNo){
            let mberInfo = {
              xScmToken : response.headers['x-scm-token'],
              xRefToken : response.headers['x-ref-token'],
              mberNo : mberNo
            }
            store.commit("setMberInfo", mberInfo);
          }
        }
      } catch (error) {
        this.awardCodeCheck = false;
      }
    },
    /**
     * 회원 초기화
     */
     mberInit() {
      let mberInfo = {
        xScmToken : '',
        xRefToken : '',
        mberNo : ''
      }
      store.commit("setMberInfo", mberInfo);
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/assets/styles/pages/award/awardCode.scss';

</style>